module.exports = __webpack_public_path__ + "img/MTABAPPDBP.e5958ce2.svg";